function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import 'rc-tooltip/assets/bootstrap.css';
import Slider from 'rc-slider';
import raf from 'rc-util/lib/raf';
import Tooltip from 'rc-tooltip';
const HandleTooltip = props => {
  const {
    value,
    children,
    visible,
    tipFormatter = val => `${val} %`,
    ...restProps
  } = props;
  const tooltipRef = React.useRef();
  const rafRef = React.useRef(null);
  function cancelKeepAlign() {
    raf.cancel(rafRef.current);
  }
  function keepAlign() {
    rafRef.current = raf(() => {
      var _tooltipRef$current;
      (_tooltipRef$current = tooltipRef.current) === null || _tooltipRef$current === void 0 ? void 0 : _tooltipRef$current.forceAlign();
    });
  }
  React.useEffect(() => {
    if (visible) {
      keepAlign();
    } else {
      cancelKeepAlign();
    }
    return cancelKeepAlign;
  }, [value, visible]);
  return /*#__PURE__*/React.createElement(Tooltip, _extends({
    placement: "bottom",
    overlay: tipFormatter(value),
    overlayInnerStyle: {
      minHeight: 'auto'
    },
    ref: tooltipRef,
    visible: visible
  }, restProps), children);
};
export const handleRender = (node, props) => {
  return /*#__PURE__*/React.createElement(HandleTooltip, {
    value: props.value,
    visible: props.dragging
  }, node);
};
const TooltipSlider = ({
  tipFormatter,
  tipProps,
  ...props
}) => {
  const tipHandleRender = (node, handleProps) => {
    return /*#__PURE__*/React.createElement(HandleTooltip, _extends({
      value: handleProps.value,
      visible: handleProps.dragging,
      tipFormatter: tipFormatter
    }, tipProps), node);
  };
  return /*#__PURE__*/React.createElement(Slider, _extends({}, props, {
    handleRender: tipHandleRender
  }));
};
export default TooltipSlider;